(() => {
  function init(scope) {
    scope.querySelectorAll('[data-ab-thumbnail-slider]').forEach((slider) => {
      if (slider.dataset.sliderReady) return;
      slider.dataset.sliderReady = 'true';
      const track = slider.querySelector('.product-media--thumbs-wrapper');
      const prev = slider.querySelector('[data-thumbs-prev]');
      const next = slider.querySelector('[data-thumbs-next]');
      const mobile = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const behavior = () => reducedMotion.matches ? 'auto' : 'smooth';

      function update() {
        prev.hidden = next.hidden = !mobile.matches;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function revealActive() {
        if (!mobile.matches) return;
        const active = track.querySelector('[data-active="true"]');
        if (!active) return;
        const bounds = track.getBoundingClientRect();
        const item = active.getBoundingClientRect();
        const delta = item.left < bounds.left ? item.left - bounds.left - 3
          : item.right > bounds.right ? item.right - bounds.right + 3 : 0;
        if (delta) track.scrollBy({ left: delta, behavior: behavior() });
      }

      prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .8, behavior: behavior() }));
      next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .8, behavior: behavior() }));
      track.addEventListener('scroll', update, { passive: true });
      const activeObserver = new MutationObserver(() => requestAnimationFrame(revealActive));
      activeObserver.observe(track, { subtree: true, attributes: true, attributeFilter: ['data-active'] });
      const sizeObserver = new ResizeObserver(update);
      sizeObserver.observe(track);
      mobile.addEventListener('change', update);
      update();
      revealActive();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
